// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33zO2","content":"styles_content__3cwMY"};